export const infoBox = () => {
    const infobox = document.getElementById('sp-infobox');
    if (!infobox) return;
    const infoboxCta = document.getElementById('sp-infobox-cta');
    const infoboxClose = document.getElementById('sp-infobox-dismiss');
    const infoboxSlug = infobox.dataset.slug;

    const INFOBOX_MODIFIER = 'sp-infobox--hidden';
    const infoboxState = localStorage.getItem(`infobox-${infoboxSlug}`);

    function handleClick(e) {
        // Dismiss link has no URL
        if (e.target.getAttribute('href') === '#') {
            e.preventDefault();
        }
        // Infobox should now be hidden
        infobox.classList.add(INFOBOX_MODIFIER);
        localStorage.setItem(`infobox-${infoboxSlug}`, 'hide');
    }

    if (infoboxState !== 'hide') {
        infobox.classList.remove(INFOBOX_MODIFIER);
    }

    // If any of the infoboxes buttons is clicked, set localStorage
    infoboxCta.addEventListener('click', handleClick);
    infoboxClose.addEventListener('click', handleClick);
};
